module.exports = __webpack_public_path__ + "img/sankaku_25_blue.1ff8acaf.png";